import React, { ReactNode, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { FiltersMap } from '@wix/bex-core';
import { CardsGridState } from '../../state';
import { InitialSkeletonLoader } from '../InitialLoader/InitialSkeletonLoader';
import { PageGridInfiniteScrollLoader } from '../PageGridInfiniteScrollLoader';
import { Box } from '@wix/design-system';

export interface CardsGridContentProps<T, F extends FiltersMap> {
  children?: ReactNode;
  state: CardsGridState<T, F>;
}

function _CardsGridContent<T, F extends FiltersMap = FiltersMap>(
  props: CardsGridContentProps<T, F>,
) {
  const { state, children } = props;

  const {
    toolbar: {
      contentPaddingPx,
      showInitialLoader,
      multi: { showRefreshLoader },
    },
  } = state;

  let child;

  if (showRefreshLoader || showInitialLoader) {
    child = (
      <InitialSkeletonLoader
        dataHook={
          showInitialLoader ? 'grid-initial-loader' : 'grid-refresh-loader'
        }
        state={state.grid}
      />
    );
  } else {
    child = (
      <>
        {children}
        <PageGridInfiniteScrollLoader
          dataHook="infinite-scroll-loader"
          state={state.grid}
          scrollMoreAlways
        />
      </>
    );
  }

  useEffect(() => state.grid._containerRectState.init(), []);

  return (
    <Box
      direction="vertical"
      paddingTop={contentPaddingPx}
      paddingRight={contentPaddingPx}
      paddingLeft={contentPaddingPx}
    >
      <div
        ref={(el) => {
          state.grid._containerRectState.element = el;
        }}
      >
        {child}
      </div>
    </Box>
  );
}

export const CardsGridContent = observer(_CardsGridContent);
